import { useQuery } from "@tanstack/react-query";

import api from "../../api";

import type { gcpProjectIndexItem } from "../../types/gcpProject";

const useApprovedGcpProjects = (enabled: boolean = true) => {
  return useQuery({
    queryKey: ['approvedGcpProjects'],
    enabled,
    queryFn: () => api.gcpProjects.getgcpProjects(true),
    select(data) {
      return data.body as Array<gcpProjectIndexItem>
    }
  })
}

export default useApprovedGcpProjects